import { render, staticRenderFns } from "./transfer_order_statistics.vue?vue&type=template&id=f8122f14&scoped=true"
import script from "./transfer_order_statistics.vue?vue&type=script&lang=ts"
export * from "./transfer_order_statistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8122f14",
  null
  
)

export default component.exports